export class NativeStreamAggregationSubMetric {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "string",
            "format": ""
        },
        {
            "name": "expression",
            "baseName": "expression",
            "type": "string",
            "format": ""
        },
        {
            "name": "k",
            "baseName": "k",
            "type": "number",
            "format": ""
        },
        {
            "name": "lgK",
            "baseName": "lgK",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationSubMetric.attributeTypeMap;
    }
    constructor() {
    }
}
